import { z } from 'zod';
import { RecurringInvoicePeriodicitySchema } from './recurring';
/**
 * M11 — Catálogo configurable de líneas de servicio (Ajustes → Líneas de servicio).
 *
 * El código es el valor persistido en opportunity/product/rate/expense.serviceLine
 * y es INMUTABLE una vez creado (los datos históricos lo referencian). Las líneas
 * no se borran: se desactivan (active=false) y dejan de ofrecerse en selectores.
 *
 * Recurrencia: si isRecurring, el wizard del plan de facturación prellena una
 * cuota con esta periodicidad/día y defaultOccurrences como vigencia (null =
 * sin fecha límite → alerta de renovación).
 */
const SERVICE_LINE_CODE_REGEX = /^[A-Z0-9_]+$/;
export const ServiceLineDefDtoSchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    active: z.boolean(),
    position: z.number().int(),
    isDefault: z.boolean(),
    isRecurring: z.boolean(),
    periodicity: RecurringInvoicePeriodicitySchema.nullable(),
    defaultDayOfMonth: z.number().int().nullable(),
    defaultOccurrences: z.number().int().nullable(),
    createdAt: z.string().datetime(),
});
export const CreateServiceLineSchema = z.object({
    // Código INMUTABLE y transparente: la UI ya no lo pide. Si no se envía, el
    // backend lo genera a partir del nombre (slug en MAYÚSCULAS). Se acepta
    // opcionalmente por compatibilidad (imports, seeds, migraciones).
    code: z
        .string()
        .min(2)
        .max(64)
        .regex(SERVICE_LINE_CODE_REGEX, 'Solo mayúsculas, dígitos y guion bajo')
        .transform((v) => v.toUpperCase())
        .optional(),
    name: z.string().min(2).max(200),
    description: z.string().max(1000).nullable().optional(),
    active: z.boolean().default(true),
    position: z.number().int().min(0).default(0),
    isDefault: z.boolean().default(false),
    isRecurring: z.boolean().default(false),
    periodicity: RecurringInvoicePeriodicitySchema.nullable().optional(),
    defaultDayOfMonth: z.number().int().min(1).max(28).nullable().optional(),
    defaultOccurrences: z.number().int().positive().nullable().optional(),
});
/** El code NO es editable (los datos históricos lo referencian). */
export const UpdateServiceLineSchema = CreateServiceLineSchema.omit({ code: true }).partial();
export const ServiceLineListResponseSchema = z.object({
    items: z.array(ServiceLineDefDtoSchema),
});
//# sourceMappingURL=service-lines.js.map